export default "__VITE_ASSET__B8vx5f11__"